import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Package, Settings, Map, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const UmrahSelectionPage = () => {
  const navigate = useNavigate();

  const options = [
    {
      id: 'mandiri-la',
      title: 'Paket LA',
      subtitle: 'Pilih Paket LA',
      description: 'Paket Land Arrangement (LA) dengan pilihan hotel dan fasilitas yang sudah diatur oleh travel partner.',
      icon: Map,
      features: [
        'Paket LA lengkap siap pakai',
        'Hotel dan fasilitas tersedia',
        'Harga sudah termasuk pengaturan',
        'Tanpa repot memilih sendiri',
        'Ideal untuk yang ingin praktis'
      ],
      color: 'from-purple-500 to-pink-500',
      action: () => navigate('/la-packages')
    },
    {
      id: 'mandiri-selera',
      title: 'Umrah Mandiri',
      subtitle: 'Sesuai Selera',
      description: 'Atur sendiri seluruh kebutuhan perjalanan Umrah Anda. Pilih hotel, maskapai, muthowif, dan fasilitas sesuai keinginan.',
      icon: Settings,
      features: [
        'Pilih hotel sesuai budget',
        'Tentukan maskapai favorit',
        'Pilih muthowif berpengalaman',
        'Atur transportasi sendiri',
        'Fleksibel & Customizable'
      ],
      color: 'from-blue-500 to-cyan-500',
      action: () => navigate('/umrah-mandiri')
    },
    {
      id: 'travel',
      title: 'Paket Umrah Travel',
      subtitle: 'Paket Lengkap',
      description: 'Paket lengkap yang sudah diatur oleh travel. Tinggal pilih paket yang sesuai dan berangkat.',
      icon: Package,
      features: [
        'Paket sudah termasuk semua',
        'Harga lebih ekonomis',
        'Tidak perlu repot atur',
        'Sudah teruji & terpercaya',
        'Ready to Go'
      ],
      color: 'from-emerald-500 to-teal-500',
      action: () => navigate('/packages')
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/20 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <motion.h1 
            className="text-5xl font-bold font-['Outfit'] mb-4"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Pilih Jenis Umrah Anda
          </motion.h1>
          <motion.p 
            className="text-xl text-muted-foreground"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            Mau atur sendiri atau pilih paket yang sudah tersedia?
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {options.map((option, index) => {
            const Icon = option.icon;
            return (
              <motion.div
                key={option.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
              >
                <Card className="rounded-3xl h-full hover:shadow-2xl transition-shadow duration-300 border-2 hover:border-primary">
                  <CardHeader>
                    <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${option.color} flex items-center justify-center mb-4`}>
                      <Icon className="h-8 w-8 text-white" />
                    </div>
                    <CardTitle className="text-3xl font-['Outfit']">
                      {option.title}
                    </CardTitle>
                    <CardDescription className="text-base mt-2">
                      {option.description}
                    </CardDescription>
                  </CardHeader>
                  
                  <CardContent>
                    <div className="space-y-3 mb-6">
                      {option.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2">
                          <div className="w-2 h-2 rounded-full bg-primary" />
                          <span className="text-sm text-muted-foreground">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <Button 
                      className="w-full rounded-full text-lg py-6"
                      size="lg"
                      onClick={option.action}
                    >
                      Pilih {option.title}
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">Butuh bantuan memilih?</p>
          <a href="https://wa.me/6285700040403" target="_blank" rel="noopener noreferrer">
            <Button variant="outline" className="rounded-full">
              <MessageCircle className="h-4 w-4 mr-2" />Hubungi Customer Service
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default UmrahSelectionPage;
